<template>
  <div class="ordersMGT-list-page">
    <div class="global-header-wrap">
      <div class="left-part">
        <h2>订单总量：{{ total }}</h2>
        <h2>总金额：{{ totalAmount }}</h2>
      </div>
      <div class="right-part">
        <el-popover :append-to-body="false" placement="bottom" trigger="click">
          <div class="orders-header-export">
            <div class="orders-header-export-date">
              <el-date-picker
                v-model="exportDate"
                type="daterange"
                value-format="timestamp"
                :start-placeholder="$t('commonMsg.startAt')"
                :end-placeholder="$t('commonMsg.endAt')"
              >
              </el-date-picker>
              <!-- <p class="orders-header-export-tips">
                (最多只能导出10000条记录，不选择日期会从当日开始往前导出记录)
              </p> -->
              <el-button
                type="primary"
                class="orders-header-export-config"
                @click.stop="exportDateHandle"
                >{{ $t("commonMsg.confirm") }}</el-button
              >
            </div>
          </div>
          <el-button
            slot="reference"
            class="orders-header-export-btn"
            type="primary"
            >{{ $t("commonMsg.export") }}</el-button
          >
        </el-popover>
      </div>
    </div>
    <el-card class="app-table-container" :body-style="{ padding: '20px' }">
      <div slot="header">
        <div class="global-table-header">
          <div class="left-part">
            <span>{{ $t("sale.orders.title") }}</span>
            <list-search @listSearchEvn="listSearchEvn" />
          </div>
          <div class="right-part">
            <span>{{ $t("commonMsg.date") }}</span>
            <el-date-picker
              v-model="searchDate"
              type="daterange"
              value-format="timestamp"
              :start-placeholder="$t('commonMsg.startAt')"
              :end-placeholder="$t('commonMsg.endAt')"
              @change="searchDateHandle"
            >
            </el-date-picker>
            <!-- <button class="global-button-style" @click="$router.push({name: 'add'})"><img src="@/assets/img/cmb_btn_add.png"/>{{$t('user.addUser')}}</button> -->
          </div>
        </div>
      </div>
      <div class="global-body-wrap">
        <TableView
          :tableProp="tableProp"
          :tableData="tableData"
          :handleBtn="handleBtn"
          :currentPage="currentPage"
          :pageSize="params.limit"
          @tableHandle="tableHandle"
        />
      </div>
      <Pagination
        :pageSize="params.limit"
        :total="total"
        @pageNum="getPageNum"
      />
    </el-card>
  </div>
</template>

<script>
import TableView from "@/components/tableView";
import Pagination from "@/components/pagination";
import ListSearch from "@/components/listSearch";

export default {
  components: {
    TableView,
    Pagination,
    ListSearch,
  },
  computed: {
    tableProp() {
      let tableProp = [
        {
          prop: "user.id",
          label: this.$t("user.id"),
          obj: true,
        },
        {
          prop: "user.nickname",
          label: this.$t("user.username"),
          obj: true,
        },
        {
          prop: "des",
          label: this.$t("sale.orders.des"),
        },
        // {
        //   prop: "vip_type",
        //   label: this.$t("sale.orders.vip_type")
        // },
        {
          prop: "created_at",
          label: this.$t("commonMsg.createdAt"),
        },
        {
          prop: "fee_type",
          label: this.$t("sale.orders.fee_type"),
        },
        {
          prop: "pay_time",
          label: this.$t("sale.orders.pay_time"),
        },
        {
          prop: "order_total",
          label: this.$t("sale.orders.total"),
        },
        {
          prop: "orders_status",
          label: this.$t("sale.orders.status"),
        },
        {
          prop: "out_trade_no",
          label: this.$t("sale.orders.out_trade_no"),
        },
      ];
      return tableProp;
    },
    handleBtn() {
      return [{ style: "checkDetailsBtn", type: "details", title: "详情" }];
    },
  },
  data() {
    return {
      tableData: [],
      total: 0,
      totalAmount: 0,
      currentPage: 1,
      params: { limit: 20, offset: 0, source_type: "vn" },
      searchDate: [],
      exportDate: [],
    };
  },
  methods: {
    async getList() {
      let res = await this.$http.getOrders(this.params);
      this.total = res.data.count;
      this.totalAmount = res.data.totalAmount;
      this.tableData = res.data.rows;
    },

    async exportDateHandle() {
      try {
        let [startDate, endDate] =
          this.exportDate && this.exportDate.length ? this.exportDate : [];
        let res = await this.$http.exportOrdersData({
          startDate,
          endDate,
          source_type: "vn",
        });
        if (!res.data) return;
        const tempLink = document.createElement("a");
        tempLink.style.display = "none";
        document.body.appendChild(tempLink);
        tempLink.setAttribute("href", res.data);
        tempLink.click();
        document.body.removeChild(tempLink);
      } catch (error) {
        if (error.response.data) {
          this.elMsg(error.response.data.message, "error");
        }
      }
    },

    async tableHandle(obj) {
      let { type, data } = obj;
      if (type === "details") {
        this.$router.push({ name: "vnDetails", query: { i: data.id } });
      }
    },

    searchDateHandle(date) {
      if (date) {
        [this.params.startDate, this.params.endDate] = date;
      } else {
        delete this.params.startDate;
        delete this.params.endDate;
      }
      this.getList();
    },

    listSearchEvn(val) {
      this.params.text = val;
      if (!this.params.text) delete this.params.text;
      this.getList();
    },

    getPageNum(val) {
      this.currentPage = val;
      this.params.offset = (val - 1) * this.params.limit;
      this.getList();
    },
  },
  mounted() {
    this.getList();
  },
};
</script>

<style lang="scss" scoped>
.ordersMGT-list-page {
  height: 100%;
  display: flex;
  flex-direction: column;
  .left-part {
    flex: 1;
    display: flex;
    align-items: center;
    > h2 + h2 {
      margin-left: 40px;
    }
    > span {
      margin-right: 10px;
      font-size: 16px;
    }
    .global-button-style {
      margin: 0;
    }
  }
  .right-part {
    .orders-header-export-btn {
      margin-left: 20px;
    }
    > span {
      margin-right: 10px;
      font-size: 16px;
    }
    .orders-header-export {
      display: flex;
      .orders-header-export-handle {
        margin-right: 12px;
        padding-right: 12px;
        border-right: 1px solid #ebeef5;
      }
      .orders-header-export-date {
        display: flex;
        flex-direction: column;
        .orders-header-export-type {
          margin-bottom: 12px;
        }
        .orders-header-export-tips {
          text-align: center;
          color: red;
          margin: 10px 0;
        }
        .orders-header-export-config {
          margin-top: 10px;
        }
      }
    }
  }
}
</style>
